import { lazy } from "react";

export const DictionaryValueEdit = lazy(
  () => import("./dictionary-value-edit"),
);
export { DICTIONARY_VALUE_EDIT_PATH } from "./dictionary-value-edit-path";
